export const formatOrderNumber = (orderId: number) => orderId.toString().padStart(5, '0');
